import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-auth-redirect',
    template: '',
    standalone: false
})
export class AuthRedirectComponent implements OnInit {

  constructor(private router: Router, private logger: NGXLogger) {}

  ngOnInit(): void {
    console.log('AuthRedirectComponent initialized');
    this.logger.info('Redirecting to dashboard from AuthRedirectComponent');
    this.router.navigate(['/dashboard']);
  }

}